
import Vue, { PropType } from 'vue'
import { TranslateResult } from 'vue-i18n'
import { AlertButton, AlertButtonParams } from '~/models/generic/alert-button'
import CustomScroll from '~/components/_general/CustomScroll.vue'
import MarkdownElement from '~/components/markdown/Element.vue'
import SiteButton, { ButtonColor } from '~/components/site/Button.vue'
import SiteButtonSpinner from '~/components/site/ButtonSpinner.vue'
import { AlertButtonEvent } from '~/assets/ts/utils/site'

interface ModalButton extends AlertButtonParams {
  color: ButtonColor
}

export default Vue.extend({
  name: 'AlertModal',
  components: {
    SiteButtonSpinner,
    SiteButton,
    MarkdownElement,
    CustomScroll,
  },
  props: {
    title: {
      type: String as PropType<TranslateResult>,
      default: undefined,
    },
    text: {
      type: String as PropType<TranslateResult>,
      default: undefined,
    },
    neutral: {
      type: Object as PropType<AlertButton | AlertButtonParams>,
      default: undefined,
    },
    positive: {
      type: Object as PropType<AlertButton | AlertButtonParams>,
      default: undefined,
    },
    negative: {
      type: Object as PropType<AlertButton | AlertButtonParams>,
      default: undefined,
    },
    component: {
      type: [Function, String],
      default: undefined,
    },
    theme: {
      type: Boolean,
      default: true,
    },
    componentProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      waiting: false,
    }
  },
  computed: {
    hasButtons(): boolean {
      return this.buttons.length > 0
    },
    buttons(): ModalButton[] {
      const arr = [] as ModalButton[]
      if (this.neutral) {
        arr.push({
          ...this.neutral,
          color: 'gray',
        })
      }
      if (this.negative) {
        arr.push({
          ...this.negative,
          color: 'red',
        })
      }
      if (this.positive) {
        arr.push({
          ...this.positive,
          color: 'blue',
        })
      }
      return arr
    },
  },
  beforeDestroy() {
    this.$store.commit('site/SET_MODAL_OPEN', false)
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async click(e: Event, buttonEvent?: AlertButtonEvent) {
      if (!buttonEvent) return this.close()
      const cb = buttonEvent(e)
      const isPromise = typeof cb === 'object' && !!cb.then
      if (isPromise) {
        this.waiting = true
        const response = await cb
        if (response !== false) {
          this.close()
        }
        this.waiting = false
      } else if (cb !== false) {
        this.close()
      }
    },
  },
})
